export enum NotificationChannel {
    EMAIL = 'email',
    SMS = 'sms'
}
